import React from 'react';
import { Panel, Col, Row } from 'react-bootstrap';

import {
  statusTypes
} from "../config/constants";
import PTRequirementsValidation from "../validation/ptRequirementsValidation";

const PTRequirementsSummary = (props) => {
  const withoutValidation = props.withoutValidation;
  const validationStatus = new PTRequirementsValidation().getValidationStatus(props);

  return(
    <Panel className="ptrequirements-info-panel" header="PT Requirements" bsStyle={withoutValidation ? statusTypes.INFO : validationStatus.section.status}>
      <Row>
        <Col md={4}>
          <h3 className="summary-sub-category">Secondary Education</h3>
          <p>{props.hsOrGED ? 'High School or Equivalent Completed' : 'Requirement Not Satisfied'}</p>
        </Col>
        <Col md={4}>
          <h3 className="summary-sub-category">Veteran Status</h3>
          <p>{props.veteran ? 'Veteran' : 'Not a Veteran'}</p>
        </Col>
        <Col md={4}>
          <h3 className="summary-sub-category">Previous Experience</h3>
          <p>{props.transferOption ? 'Transfer Requested' : 'Not Eligible or Transfer Not Requested'}</p>
        </Col>
      </Row>
    </Panel>
  );
};

export default PTRequirementsSummary;